import { processJson } from './processJson'

export function parseBase64<T>(base64String: string): T | null {
  const encodedString = Buffer.from(base64String, 'base64').toString('utf8')

  return processJson(encodedString) || null
}
